import React from 'react';
import { Modal, Button, Card } from 'antd';
import holdingPhone from '../../../images/holding_phone.png';
import './MobileAppModal.scss';
import { useTranslation } from 'react-i18next';

interface MobileAppModalProps {
    open: boolean;
    onClose: () => void;
}

const MobileAppModal: React.FC<MobileAppModalProps> = ({ open, onClose }) => {
    const { t } = useTranslation();
    return (
        <Modal
            open={open}
            onCancel={onClose}
            centered
            width={500}
            className="custom-modal"
            style={{ padding: 0 }}
            closeIcon={null}
            footer={null}
        >
            <Card
                style={{ width: '100%', margin: 0 }}
                cover={<img alt="Holding Phone" src={holdingPhone} style={{ width: '100%', height: 'auto' }} />}
            >
                <p>{t('mobileAppModal.description')}</p>
                <div className="button-container">
                    <Button key="close" type='primary' onClick={onClose}>
                        {t('mobileAppModal.close')}
                    </Button>
                </div>
            </Card>
        </Modal>
    );
};

export default MobileAppModal;
